import {
  Box,
  Button,
  List,
  ListItem,
  ListItemText,
  Typography,
} from "@mui/material";
import React from "react";
import { CourseDataInfo } from "../../../../../../types";

interface CourseIncludesPreviewProps {
  courseDetails: CourseDataInfo | undefined;
}

export const CourseIncludesPreview = ({
  courseDetails,
}: CourseIncludesPreviewProps) => {
  const listItems = [
    `${courseDetails?.content?.all_hours} ч видео по запросу`,
    `${courseDetails?.info?.count_articles} статьи`,
    `${
      courseDetails?.info?.count_download_resources || 0
    } ресурсов для скачивания`,
    "Доступ через мобильные устройства и телевизор",
    "Полный пожизненный доступ",
    "Сертификат об окончании",
  ];

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
      }}>
      <Typography
        sx={{
          fontSize: "20px",
          fontWeight: 800,
          color: "#000",
          marginTop: "24px",
        }}>
        Курс включает в себя:
      </Typography>

      <List sx={{ width: "100%" }}>
        {listItems.map((item, index) => (
          <ListItem key={index} disablePadding>
            <Typography
              sx={{
                paddingRight: "8px",
              }}>
              •
            </Typography>
            <ListItemText
              sx={{
                fontSize: "18px",
                fontWeight: 400,
                color: "#000",
              }}
              primary={item}
            />
          </ListItem>
        ))}
      </List>
      <Button
        sx={{
          padding: "10px 16px",
          borderRadius: "8px",
          marginBottom: "24px",
        }}
        fullWidth
        variant="outlined">
        <Typography
          sx={{
            fontSize: "16px",
            fontWeight: 800,
            color: "primary.main",
          }}>
          Поделиться
        </Typography>
      </Button>
    </Box>
  );
};
